// extracted by mini-css-extract-plugin
module.exports = {"titleWrap":"titleWrap_2UN__2LF"};